// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import HowToBuy from "./pages/HowToBuy";
import About from "./pages/About";
import Vote from "./pages/Vote";
import Giveaway from "./pages/Giveaway";


import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import NewPost from "./pages/admin/NewPost";
import EditPost from "./pages/admin/EditPost";

import AuthProvider from "./auth/AuthContext";
import RequireAdmin from "./auth/RequireAdmin";

import "./styles/App.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />
        <Navbar />

        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/how-to-buy" element={<HowToBuy />} />
          <Route path="/about" element={<About />} />
          <Route path="/vote" element={<Vote />} />
          <Route path="/giveaway" element={<Giveaway />} />

          {/* BLOG (PUBLIC) */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          {/* Admin auth */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Admin protected */}
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/new"
            element={
              <RequireAdmin>
                <NewPost />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/edit/:slug"
            element={
              <RequireAdmin>
                <EditPost />
              </RequireAdmin>
            }
          />

          {/* Optional 404 fallback */}
          {/* <Route path="*" element={<Home />} /> */}
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
